import { render, staticRenderFns } from "./Experience.vue?vue&type=template&id=229915be&scoped=true&"
import script from "./Experience.vue?vue&type=script&lang=js&"
export * from "./Experience.vue?vue&type=script&lang=js&"
import style0 from "./Experience.vue?vue&type=style&index=0&id=229915be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229915be",
  null
  
)

export default component.exports